import { SkyText } from "@skypointcloud/skypoint-ui";
import Loader from "../shared/loader";
import { Styles } from "./SkypointLogoLoader.styles";
import { Styles as common } from "../../styles/common.styles";

const SkypointLogoLoader = () => {
  return (
    <>
      <style>
        {`
          @keyframes fadeIn {
            from {
              opacity: 0;
              transform: translateY(10px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
        `}
      </style>
      <div style={Styles.wrapper}>
        <div style={Styles.logoContainer}>
          <img
            src="/dist/img/skyAdvisor_Dark.svg"
            alt="skyAdvisor Logo"
            style={Styles.logoImage}
          />
        </div>

        <div style={Styles.loaderWrapper}>
          <Loader />
        </div>

        <div style={Styles.poweredByWrapper}>
          <SkyText style={common.boldText}>Powered by</SkyText>
          <img
            src="/dist/img/skyPoint-logo-text-black.svg"
            style={Styles.poweredByImage}
            alt="Skypoint"
          />
        </div>
      </div>
    </>
  );
};

export default SkypointLogoLoader;
